import { httpTools } from "@lib/redux/http-utils";
import { apiSlice } from "@features/application/api-slice";
import { createBulkReadMutation } from "@features/feed/bulk-read";
import routes from "@features/routes";
import {
  WorkspaceEntity,
  WorkspaceInputView,
  WorkspaceOutputView,
} from "@features/workspaces/types/workspace";
import {
  WorkspaceStreamEntity,
  WorkspaceStreamOutputView,
} from "@features/workspaces/types/workspace-stream";
import { workspaceStreamsTools } from "@features/workspaces/workspace-streams-tools";
import { workspacesTools } from "@features/workspaces/workspaces-tools";

const convertToDomainEntity = (data?: WorkspaceOutputView) =>
  data ? workspacesTools.convertToDomainEntity(data) : undefined;

export const workspacesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspaces: httpTools.getMultipleResponse<WorkspaceOutputView, WorkspaceEntity>(
      builder,
      routes.workspaces.api.workspaces,
      "Workspace",
      (data) => data?.map(workspacesTools.convertToDomainEntity).sort(workspacesTools.sortByTitle),
    ),
    getWorkspace: httpTools.getOnceResponse<WorkspaceOutputView, WorkspaceEntity>(
      builder,
      routes.workspaces.api.workspace,
      "Workspace",
      convertToDomainEntity,
    ),
    patchWorkspace: httpTools.patchOnceResponse<
      WorkspaceOutputView,
      WorkspaceEntity,
      WorkspaceInputView
    >(builder, routes.workspaces.api.workspace, "Workspace", convertToDomainEntity),
    postWorkspace: httpTools.postOnceResponse<
      WorkspaceOutputView,
      WorkspaceEntity,
      WorkspaceInputView
    >(builder, routes.workspaces.api.workspaces, "Workspace", convertToDomainEntity),
    getWorkspaceStreams: httpTools.getMultipleResponse<
      WorkspaceStreamOutputView,
      WorkspaceStreamEntity
    >(builder, routes.workspaces.api.workspace_streams, null, (data) =>
      data?.map(workspaceStreamsTools.convertToDomainEntity).sort(workspaceStreamsTools.sortByName),
    ),
    bulkReadWorkspaces: createBulkReadMutation<WorkspaceOutputView>(
      builder,
      routes.workspaces.api.workspaces_bulk_read,
    ),
  }),
  overrideExisting: false,
});

export const {
  useGetWorkspacesQuery,
  useGetWorkspaceQuery,
  useGetWorkspaceStreamsQuery,
  usePatchWorkspaceMutation,
  usePostWorkspaceMutation,
  useBulkReadWorkspacesMutation,
} = workspacesApi;
